<script lang="ts">
    import Fa from 'svelte-fa'
    import Zframe from '../_common/z/zframe.svelte'
    import { faSave } from '@fortawesome/free-solid-svg-icons'
    import { createEventDispatcher } from 'svelte'
    const dispatch = createEventDispatcher()

    let cashOpen: number = 0

    async function saveEntity() {
        try {
            const result = await window.api.pos.cashiers.create({ cashOpen })
            if (result) {
                dispatch('open', result.cashierId)
            }
        } catch (error) {
            window.error(error)
        }
    }
</script>

<div class="grid-act">
    <div class="spacer" />
    {#if window.store.token.permissions.pos.sales.write}
        <button class="btn btn-primary" on:click={saveEntity}><Fa icon={faSave} /> Salvar</button>
    {/if}
</div>
<Zframe class="m-3" title="Abertura de Caixa">
    <div class="row">
        <div class="col">
            <div class="input-group">
                <label for="" class="input-group-text">Saldo inicial (troco)</label>
                <input type="number" bind:value={cashOpen} class="form-control" />
            </div>
        </div>
    </div>
</Zframe>
